import React from 'react';
import { Switch } from 'react-router-dom';
import Route from './Route';

// Pages
import Index from '../Pages/index';

export default function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={Index} />
    </Switch>
  );
}
